<template>
  <!-- Modal Duplicate -->
  <transition name="modal">
    <div class="modal-mask" style="display: block">
      <div class="modal-dialog modal modal-special" role="document">
        <div class="modal__content modal__content--md">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
          >
            <h2 class="font-medium text-base mr-auto">
              <template v-if="!task_validated"> Duplicar Tarea </template>
              <template v-else> Confirmar Tarea </template>
            </h2>
          </div>
          <Loading v-if="isLoading" />
          <form
            @submit.prevent="createDuplicateTask"
            enctype="multipart/form-data"
            class="form-task"
            v-else
          >
            <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
              <div class="col-span-12 sm:col-span-12">
                <label>Nombre</label>
                <input
                  type="text"
                  class="input w-full border mt-2 flex-1"
                  v-model="task_duplicate.name"
                  required
                  :class="{ 'border-theme-12': task_validated }"
                />
              </div>
              <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
                <label>Descripcion</label>
                <textarea
                  class="input w-full border mt-2"
                  rows="3"
                  v-model="task_duplicate.description"
                  :class="{ 'border-theme-12': task_validated }"
                ></textarea>
              </div>
              <div class="col-span-12 sm:col-span-6">
                <label>Fecha de entrega</label>
                <input
                  type="date"
                  class="input w-full border mt-2 flex-1"
                  v-model="task_duplicate.date"
                  required
                  :class="{ 'border-theme-12': task_validated }"
                />
              </div>
              <div class="col-span-12 sm:col-span-6">
                <label>Proyecto</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="task_duplicate.project_id"
                  required
                  :class="{ 'border-theme-12': task_validated }"
                  disabled
                >
                  <option value="" disabled>Seleccione...</option>
                  <option v-for="project in projects" :value="project.id">
                    {{ project.name }} - {{ project.account.name }}
                    {{ project.account.country.prefix }}
                  </option>
                </select>
              </div>
              <div class="col-span-12 sm:col-span-6">
                <label>Campaña</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="task_duplicate.campaign_id"
                  required
                  :class="{ 'border-theme-12': task_validated }"
                  disabled
                >
                  <option value="" disabled>Seleccione...</option>
                  <option v-for="campaign in campaigns" :value="campaign.id">
                    {{ campaign.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-12 sm:col-span-6 hidden">
                <label>Equipo</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="task_duplicate.team_id"
                  required
                  :class="{ 'border-theme-12': task_validated }"
                  disabled
                >
                  <option disabled>Seleccione el equipo</option>
                  <option v-for="team in teams" :value="team.id">
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-12 sm:col-span-6">
                <label>Url Archivo (opcional)</label>
                <MultiSelect
                  v-model="task_duplicate.path"
                  :options="options"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag"
                  class="mt-2"
                  :class="{ 'border-theme-12 border': task_validated }"
                  :disabled="task_validated"
                />
              </div>

              <div
                class="col-span-12 sm:col-span-12"
                v-if="task_loading < 11 && 0 < task_loading"
              >
                <p class="text-theme-1 font-extrabold block">
                  El botón se activara en {{ task_loading }} segundos, mientras
                  verificas la información.
                </p>
              </div>
            </div>

            <div
              class="px-5 py-3 text-right border-t border-gray-200"
              v-show="!task_validated"
            >
              <button
                type="button"
                @click="clearDuplicateTask()"
                class="button w-20 border text-gray-700 mr-1"
              >
                Cancelar
              </button>
              <button type="submit" class="button bg-theme-1 text-white">
                Verificar Tarea
              </button>
            </div>
            <div
              class="px-5 py-3 text-right border-t border-gray-200"
              v-show="task_validated"
            >
              <a
                type="button"
                @click="task_validated = !task_validated"
                class="button w-20 border text-gray-700 mr-1"
                >Cancelar</a
              >
              <button
                type="submit"
                class="button bg-theme-1 text-white"
                id="create_duplicate"
              >
                Confirmar Tarea
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
  <!-- Modal Duplicate End -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'

export default {
  props: ['task'],
  data() {
    return {
      task_duplicate: {},
      task_loading: 11,
      task_validated: false,
      options: [],
      isLoading: false,
    }
  },
  created() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = null
  },
  async beforeMount() {
    this.isLoading = true
    let query = `account_session=${localStorage.session_account}`
    try {
      await Promise.all([
        this.getList(['project', query]),
        this.getList(['campaign', query]),
      ])
      await this.duplicateTask()
      this.isLoading = false
    } catch (error) {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions(['getList']),
    async duplicateTask() {
      this.task_duplicate = JSON.parse(JSON.stringify(this.task))
      //console.log(this.task_duplicate)
      this.task_duplicate.path = this.task_duplicate.path.split(',')
      this.showDuplicateModal = true
    },
    clearDuplicateTask() {
      this.task_duplicate = {}
      this.showDuplicateModal = false
      this.$emit('clearDuplicateTask')
    },
    addTag(newTag) {
      this.options.push(newTag)
    },
    createDuplicateTask() {
      var vm = this

      if (this.task_validated) {
        window.$('#create_duplicate').button('loading')

        vm.task_duplicate.response_observations = null
        vm.task_duplicate.response_path = null
        vm.task_duplicate.state_id = 1
        vm.task_duplicate.entity = 'task'

        vm.store(vm.task_duplicate)
          .then((item) => {
            this.clearDuplicateTask()
            window.location.reload()
          })
          .catch((error) => {
            console.log('FAILURE!!')
          })
          .finally(() => {
            window.$('#create_duplicate').button('reset')
            vm.loading = true
          })
      } else {
        vm.task_validated = !vm.task_validated
        window.$('#create_duplicate').button('loading')
        setTimeout(() => {
          window.$('#create_duplicate').button('reset')
        }, 10000)
        let interval = setInterval(function () {
          addSeconds()
        }, 1000)

        function addSeconds() {
          if (vm.task_loading > 0) {
            vm.task_loading = vm.task_loading - 1
          } else {
            clearInterval(interval)
          }
        }

        this.task_loading = 11
      }
    },
    ...mapActions(['store']),
  },
  computed: {
    ...mapGetters({
      projects: 'getProjects',
      campaigns: 'getCampaigns',
      teams: 'getTeams',
    }),
  },
  components: {
    MultiSelect,
    Loading,
  },
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-special {
  overflow: auto;

  background-image: initial;
  background-color: initial;

  margin-top: initial;
  margin-left: initial;
  background: none;
  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;

  visibility: visible;

  padding-top: 4rem;
}

.modal-special .modal__content {
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// DuplicateTaskComponent.vue?2425e278